module.exports = __webpack_public_path__ + "static/img/014.4e28019.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/datav-eplus/014.png
// module id = QymP
// module chunks = 1